import Ad from '@/components/Ad/Ad'
// import GatherersTavernAd, { findGatherersTavernSlug } from '@/components/GatherersTavernAd/GatherersTavernAd'
import { useAds } from '@/contexts/ads'
// import useDirectories from '@/utils/useDirectories'

import styles from './MidBanner.module.scss'

// Note: (un)comment CSS if separate mobile ad (not) provided

const MidBanner = () => {
  const { loadAds } = useAds()
  // const { subpage, subsubpage } = useDirectories()

  // https://www.epochconverter.com
  const enabled = loadAds //  && Date.now() > 1780059600000 && Date.now() < 1780110000000

  // const gatherersTavernSlug = findGatherersTavernSlug([subpage, subsubpage])

  if (!enabled) return null

  return (
    <div className={styles.container}>
      {/* <OutboundLink className={styles.link} url='https://partner.tcgplayer.com/c/4913290/2947965/21018'>
        <img alt='' className='d-none d-sm-block' src={MY_IMAGE.src} />
        <img alt='' className='d-sm-none' src={MY_IMAGE.src} />
        <img alt='' src={MY_IMAGE.src} />
      </OutboundLink> */}
      <Ad id='csHobbit' unit='midbanner' />
    </div>
  )
}

export default MidBanner
